let qvthumbnails;
const cookieName = "wishlistList";
$(document).ready(() => {
  $('#siteloader').fadeOut();
  $('#spin-wrapper').fadeOut();

  // fixed header
  (function($) {
    function mediaSize() {
      if (window.matchMedia('(min-width: 992px)').matches) {
        const headerHeight = $('#header').height();
        const navHeight = $('#header .site-header-inner').height();
        $(window).scroll(() => {
          if ($(window).scrollTop() > headerHeight) {
            $('.header-top').addClass('fixed-header');
          } else {
            $('.header-top').removeClass('fixed-header');
          }
        });
      }
    }
    mediaSize();
    window.addEventListener('resize', mediaSize, false);
  })(jQuery);

  const headerHeight = $('#header').height();
  const navHeight = $('#header .mobile-width').height();
  $(window).scroll(() => {
    if ($(window).scrollTop() > headerHeight) {
      $('.mobile-width').addClass('fixed-header');
    } else {
      $('.mobile-width').removeClass('fixed-header');
    }
  });


  $("#SortTags").on("click", "a", function(e) {

    if ($(this).hasClass("selected")) {
      const tagName = $(this).data("tagname");
      var url = window.location.href;
      const tagStart = url.indexOf(tagName);
      const tagEnd = tagStart + tagName.length;

      e.preventDefault();
      if (url.charAt(tagStart - 1) == "/") {
        var url = url.replace(tagName, '');
        url = url.replace("+", '');
        window.location = url;
      } else if (url.charAt(tagEnd + 1) == "") {
        var url = url.replace(tagName, '');
        url = url.substring(0, (url.length - 1));
        window.location = url;
      } else {
        const url1 = url.substring(0, (tagStart));
        const url2 = url.substring((tagEnd + 1));
        var url = url1 + url2;
        window.location = url;
      }
    }
  });

  $('#product-thumbnails-carousel').owlCarousel({
    nav: true, // Show next and prev buttons
    navText: [
      '<i class=\'material-icons\'></i>',
      '<i class=\'material-icons\'></i>',
    ],
    dots: false,
    loop: false,
    margin: 15,
    rewind: true,
    responsive: {
      0: {
        items: 3,
      },
      544: {
        items: 4,
      },
      768: {
        items: 3,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  });

  qvthumbnails = $('#qv-thumbnails').owlCarousel({
    nav: true,
    loop: false,
    navText: [
      '<i class=\'material-icons\'></i>',
      '<i class=\'material-icons\'></i>',
    ],
    responsive: {
      0: {
        items: 3,
      },
      544: {
        items: 5,
      },
      768: {
        items: 4,
      },
      992: {
        items: 4,
      },
      1200: {
        items: 5,
      },
    },
  });

  $('input.update-cart').on('input', (e) => {
    setTimeout(() => {
      $(".update-qty").trigger('click');
    }, 800);
  });

  // slide to top
  $(window).scroll(function() {
    if ($(this).scrollTop() > 500) {
      $('#slidetop').fadeIn(500);
    } else {
      $('#slidetop').fadeOut(500);
    }
  });
  $('#slidetop').click((e) => {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0,
    }, 800);
  });

  // quantity selector quickview-modal and product-page
  $(document).on("click", ".product-form__item--quantity .button", function() {
    const n = $(".product-form__item--quantity .quantity").val();
    if ($(this).text() == "+") {
      var r = parseInt(n) + 1;
    } else {
      if (n == 1) { return; }
      var r = parseInt(n) - 1;
    }
    $('input.quantity').val(r);
    $(".update-qty").trigger('click');
  });

  // quantity selector for cart-page
  $(document).on("click", ".cart-qty-btns .button", function() {
    const n = $(this).siblings(".quantity").val();
    if ($(this).text() == "+") {
      var r = parseInt(n) + 1;
    } else {
      if (n == 1) { return; }
      var r = parseInt(n) - 1;
    }
    $(this).siblings(".quantity").val(r);
    $(".update-qty").trigger('click');
  });


  // for change grid to list view
  $(document).on('click', '.list-img', function(e) {
    if ($(this).hasClass('checked')) {

    } else {
      $('#list-img').addClass('checked');
      $('#grid-img').removeClass('checked');
      $('.products-display-collection .grid__item').each(function() {
        $(this).removeClass('small--one-half');
        $(this).removeClass('grid__item');
        $(this).removeClass(' medium-up--one-quarter');
        $(this).addClass('one-whole');
        $(this).addClass('list__item');
        initWishlistButtons();
      });
      $('.products-display-collection .grid-view-item__image-wrapper').each(function() {
        $(this).addClass('col-sm-4');
      });
      $('.products-display-collection .product-description').each(function() {
        $(this).addClass('col-sm-8');
      });

      $('#Collection').fadeOut(0);
      $('#Collection').fadeIn(500);
    }
  });
  // for change list to grid view
  $(document).on('click', '.grid-img', function(e) {
    if ($(this).hasClass('checked')) {

    } else {
      $('#list-img').removeClass('checked');
      $('#grid-img').addClass('checked');
      $('.products-display-collection .list__item').each(function() {
        $(this).addClass('small--one-half');
        $(this).addClass('grid__item');
        $(this).removeClass('one-whole');
        $(this).removeClass('list__item');
        initWishlistButtons();
      });
      $('.products-display-collection .grid-view-item__image-wrapper').each(function() {
        $(this).removeClass('col-sm-4');
      });
      $('.products-display-collection .product-description').each(function() {
        $(this).removeClass('col-sm-8');
      });

      $('#Collection').fadeOut(0);
      $('#Collection').fadeIn(500);
    }
  });

  // JS FOR LEFT COLUMN
  if ($('#left-column-category').length > 0) {
    $('#left-column-category').html($('#_desktop_top_menu').html());
    $('#left-column-category').find('.dropdown-inner').css('width', 'auto');
  }

  // to distinguish category tree id from the main menu.
  $('.category-tree').each(() => {
    function myFunction() {
      const str = document.getElementById("top-menu").innerHTML;
      const res = str.replace(/_n_/g, "_m_");
      document.getElementById("top-menu").innerHTML = res;
    }
    myFunction();
  });


  $(document).on("click", ".nm-addToCart.enable", function() {
    const variantID = $(this).parents(".add_to_cart_main").find('input[name="prduct-variant"]')
.val();
    const qty = $(this).parents(".add_to_cart_main").find('input[name="product-quantity"]')
.val();
    $(this).addClass('adding');
    productAddToCart(variantID, qty);
    if ($(".cart-display #cart-container").hasClass('in')) {
      $(".cart-display #cart-container").removeClass('in');
      $(".cart-display .cart-title").addClass('collapsed');
      $(".cart-display .cart-title").attr("aria-expanded", "false");
    }
  });

  if ($(window).width() < 992) {
    convertToMobile();
  }

  $('#menu-icon').on('click', () => {
    $("#mobile_top_menu_wrapper").animate({
      width: "toggle",
    });
    $('.mobile-menu-overlay').toggleClass("active");
  });

  $('#top_menu_closer i').on('click', () => {
    $("#mobile_top_menu_wrapper").animate({
      width: "toggle",
    });
    $('.mobile-menu-overlay').toggleClass("active");
  });

  $('.mobile-menu-overlay').on('click', () => {
    $("#mobile_top_menu_wrapper").animate({
      width: "toggle",
    });
    $('.mobile-menu-overlay').toggleClass("active");
  });



  $("#_desktop_top_menu .category").each(function (index) {
    const subdiv = $(this).find('.sub-menu .sub-category, .category-only').length;
    const submenu = $(this).find('.sub-menu');
    switch (subdiv) {
      case 1: submenu.css('width', '230px');
        submenu.css('left', calculateLeft(submenu.offset(), 230));
        break;
      case 2: submenu.css('width', '430px');
        submenu.css('left', calculateLeft(submenu.offset(), 430));
        break;
      case 3: submenu.css('width', '630px');
        submenu.css('left', calculateLeft(submenu.offset(), 630));
        break;
      case 4: submenu.css('width', '830px');
        submenu.css('left', calculateLeft(submenu.offset(), 830));
        break;
    }
  });

  function calculateLeft(offset, width) {
    const totalDivSpace = offset.left + width;
    const difference = $(window).width() - totalDivSpace;
    if (difference < 0) {
      return difference - 15;
    }
    return 0;
  }

  // JS FOR cart dropdown
  $(document).on("click", "#cart-container a.remove", function() {
    const variantID = $(this).data("variantid");
    productRemoveFormCart(variantID);

  });

  $(document).on("change", "#ProductSection-product-template select.single-option-selector", () => {
    adjustProductInventory();
  });

  $(document).on("change", "#ProductSelect-Dropdown", function() {
    $(`input[value="${$(this).attr('last')}"]`).val($(this).val());
    $(`.qv-regularprice[v${$(this).val()}]`).html(Shopify.formatMoney($(`.qv-regularprice[v${$(this).val()}]`).attr(`v${$(this).val()}`)), Shopify.money_format);
  });

  adjustCartDropDown();
  adjustProductInventory();

  updateWishlistButtons();
  initWishlistButtons();

  function initWishlistButtons() {
    if ($(".add-in-wishlist-js").length == 0) {
      return false;
    }
    $(".add-in-wishlist-js").each(function() {
      $(this).unbind();
      $(this).click(function(event) {
        event.preventDefault();
        try {
          const id = $(this).data('href');
          if ($.cookie(cookieName) == null) {
            var str = id;


          } else if ($.cookie(cookieName).indexOf(id) == -1) {
            var str = `${$.cookie(cookieName)}__${id}`;
          }
          $.cookie(cookieName, str, {expires: 14, path: '/'});
          jQuery(`.loadding-wishbutton-${id}`).show();
          jQuery(`.default-wishbutton-${id}`).remove();
          setTimeout(() => {
            jQuery(`.loadding-wishbutton-${id}`).remove(); jQuery(`.added-wishbutton-${id}`).show();

            const imessage = $("#wishlistmessage .title-success").text();
            $.notify({message: imessage}, {type: "success", offset: 0, placement: {from: "top", align: "center"}, z_index: 9999, animate: {enter: "animated fadeInDown", exit: "animated fadeOutUp"}, template: '<div data-notify="container" class="col-xs-12 alert alert-{0}" role="alert"><button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button><span data-notify="icon"></span> <span data-notify="title">{1}</span> <span data-notify="message">{2}</span><div class="progress" data-notify="progressbar"><div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div><a href="{3}" target="{4}" data-notify="url"></a></div>'});


          }, 2000);
          $(this).unbind();
        } catch (err) { } // ignore errors reading cookies
      });
    });
  }

  function updateWishlistButtons() {
    try {
      if ($.cookie(cookieName) != null && $.cookie(cookieName) != '__' && $.cookie(cookieName) != '') {
        const str = String($.cookie(cookieName)).split("__");
        for (let i = 0; i < str.length; i++) {
          if (str[i] != '') {
            jQuery(`.added-wishbutton-${str[i]}`).show();
            jQuery(`.default-wishbutton-${str[i]}`).remove();
            jQuery(`.loadding-wishbutton-${str[i]}`).remove();

          }
        }
      }
    } catch (err) { }
  }

  // STOCK URGENCY START
  const stock = parseInt($("#variant-stock").html());
  const maxqty = parseInt($(".product-single-right .progress-content").data("quantity"));
  if (stock == '' || stock <= 0) { $(".product-single-right .progress-content").addClass('hide'); }
  switch (stock) { case 9: case 8: case 7: $("#progress-bar span").css("width", "70%"); break; case 6: $("#progress-bar span").css("width", "50%"); break; case 5: $("#progress-bar span").css("width", "40%"); break; case 4: $("#progress-bar span").css("width", "30%"); break; case 3: $("#progress-bar span").css("width", "20%"); break; case 2: $("#progress-bar span").css("width", "10%"); break; case 1: $("#progress-bar span").css("width", "5%"); break; default: $("#progress-bar span").css("width", "90%"); }
  // STOCK URGENCY END

});


function convertToMobile() {
  // interchange sections
  $(document).find('.responsive-sidebar').append(`<div class="shopify-section" id="shopify-section-sidebar">${$(document).find('.normal-sidebar .shopify-section').html()}</div>`);
  $(document).find('.normal-sidebar').find('.shopify-section')
    .remove();

  $("*[id^='_desktop_']").each(function(index, element) {
    const target = $(`#${element.id.replace('_desktop_', '_mobile_')}`);
    swapElements($(this), target);
  });
}
function converToDesktop() {
  // interchange sections
  $(document).find('.normal-sidebar').append(`<div class="shopify-section" id="shopify-section-sidebar">${$(document).find('.responsive-sidebar .shopify-section').html()}</div>`);
  $(document).find('.responsive-sidebar').find('.shopify-section')
    .remove();
}

function swapElements(source, destination) {
  destination.html(source.html());
  source.html('');
}

function productRemoveFormCart(variantID) {
  jQuery.ajax({
    type: "post",
    url: "/cart/change.js",
    data: `${"quantity=0" + "&id="}${variantID}`,
    dataType: "json",
    beforeSend() {

    },
    success(n) {
      adjustCartDropDown();
    },
    error(n, r) {
    },
  });
}
function adjustCartDropDown() {
  Shopify.getCart((e) => {
    const productList = $("#cart-container .product-list");
    productList.html('');
    const cartempty = $("#cart-container .cart__empty");
    const cartfooter = $("#cart-container .cart__footer");
    $('.cart__subtotal').html(Shopify.formatMoney(e.total_price, Shopify.money_format));
    $('.cart-qty').html(e.item_count);
    if (e.items.length > 0) {
      $.each(e.items, (index, value) => {
        const product = $("<div class='product'></div>");
        const productimg = $("<div class='product-img'></div>");
        const productdata = $("<div class='product-data'></div>");
        productimg.append(`<img src='${value.image}' alt='${value.title}''>`);
        productdata.append(`<a href='${value.url}' class='product-title'>${value.title}</a>`);
        productdata.append(`<span class='product-price'>${value.quantity} x ${Shopify.formatMoney(value.discounted_price, Shopify.money_format)}</span>`);
        product.append(productimg);
        product.append(productdata);
        product.append(`<a class='remove' data-variantid=${value.variant_id}><i class='material-icons'>delete</i></a>`);
        productList.append(product);
      });
      cartfooter.removeClass('hide');
      productList.removeClass('hide');
      cartempty.addClass('hide');
      productList.slimScroll({
        height: e.items.length > 1 ? '262px' : '100%',
      });
    } else {
      cartempty.removeClass('hide');
      cartfooter.addClass('hide');
      productList.addClass('hide');
    }
  });
}


function adjustProductInventory() {
  const attr = $('#AddToCart-product-template').attr('disabled');

  if (typeof attr !== typeof undefined && attr !== false) {
    $('#inventory span.instock').hide();
    $('#inventory span.outstock').show();
  } else {
    $('#inventory span.instock').show();
    $('#inventory span.outstock').hide();
  }
}

/** ***************start animation script*******************/
jQuery(window).scroll(() => {
  hb_animated_contents();
});

function hb_animated_contents() {
  jQuery(".hb-animate-element:in-viewport").each(function(i) {
    const $this = jQuery(this);
    if (!$this.hasClass('hb-in-viewport')) {
      setTimeout(() => {
        $this.addClass('hb-in-viewport');
      }, 200 * i);
    }
  });
}

    /** ***************end animation script*******************/
